import React from "react";
//lazy loading components
import dynamic from "next/dynamic";
import { useInView } from "react-cool-inview";
import Tooltip from "@mui/material/Tooltip";
// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import NavPills from "components/NavPills/NavPills.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";

// @mui/icons-material
import Camera from "@mui/icons-material/Camera";
import Palette from "@mui/icons-material/Palette";
import People from "@mui/icons-material/People";
import Add from "@mui/icons-material/Add";
import Favorite from "@mui/icons-material/Favorite";

import styles from "./SectionPills.module.scss";

export default function SectionPills() {
  const { observe, inView } = useInView({
    onEnter: ({ unobserve }) => unobserve(), // only run once
  });
  const classes = styles;

  return (
    <div className={classes.section} ref={observe}>
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
          <NavPills
            alignCenter
            color="primary"
            tabs={[
              {
                tabButton: "All",
                tabContent: "",
              },
              {
                tabButton: "Data",
                tabContent: "",
              },
              {
                tabButton: "Marketing",
                tabContent: "",
              },
              {
                tabButton: "Tech",
                tabContent: "",
              },
              {
                tabButton: "Other",
                tabContent: "",
              },
            ]}
          />
          <div className={classes.tabSpace} />
        </GridItem>
      </GridContainer>
      <GridContainer>

      <GridItem xs={12} sm={6} md={6}>
            <Card
              raised
              background
              style={{
                backgroundImage:
                  "url('/img/posts/2025-02-04-facebook-scams/Fake-Facebook-Ad-small.jpg')",
              }}
            >
              <CardBody background>
                <h6 className={classes.category}>WARNING</h6>

                <h3 className={classes.cardTitle}>
                  WARNING FAKE FACEBOOK ADS!
                </h3>

                <p className={classes.category}>
                 There are a number of scams going around on Facebook community groups impersonating us and other businesses.
                  <br />
                  <br />
                </p>
                <h6 className={classes.cardTitle}>Posted: Jan, 2024</h6>
                <Button
                  round
                  href="/blog-post/2025/02/facebook-scams"
                  color="primary"
                >
                  <FormatAlignLeft className={classes.icons} /> Read article
                </Button>
              </CardBody>
            </Card>
          </GridItem>

      <GridItem xs={12} sm={6} md={6}>
            <Card
              raised
              background
              style={{
                backgroundImage:
                  "url('/img/posts/2024-01-15-using-streamlit-to-build-web-applications/streamlit_header.png')",
              }}
            >
              <CardBody background>
                <h6 className={classes.category}>TECH</h6>

                <h3 className={classes.cardTitle}>
                  Using Streamlit To Build Web Applications
                </h3>

                <p className={classes.category}>
                  Introduction to Streamlit: a tool to create fast and friendly web applications. 
                  <br />
                  <br />
                </p>
                <h6 className={classes.cardTitle}>Posted: Jan, 2024</h6>
                <Button
                  round
                  href="/blog-post/2024/01/using-streamlit-to-build-web-applications"
                  color="primary"
                >
                  <FormatAlignLeft className={classes.icons} /> Read article
                </Button>
              </CardBody>
            </Card>
          </GridItem>

        {inView && (
          <GridItem xs={12} sm={6} md={6}>
            <Card
              raised
              background
              style={{
                backgroundImage:
                  "url('/img/posts/2023-12-13-ga4-custom-dimensions-in-looker-studio/bp202312-4.png')",
              }}
            >
              <CardBody background>
                <h6 className={classes.category}>DATA</h6>

                <h3 className={classes.cardTitle}>
                  GA4 Custom Dimensions in Looker Studio (Data Studio)
                </h3>

                <p className={classes.category}>
                  The answer is yes. Some time from what I can gather, in midway
                  2022, Google allowed you to use your...
                  <br />
                  <br />
                </p>
                <h6 className={classes.cardTitle}>Posted: Dec, 2023</h6>
                <Button
                  round
                  href="/blog-post/2023/12/ga4-custom-dimensions-in-looker-studio"
                  color="primary"
                >
                  <FormatAlignLeft className={classes.icons} /> Read article
                </Button>
              </CardBody>
            </Card>
          </GridItem>
        )}
        <GridItem xs={12} sm={6} md={6}>
          <Card
            raised
            background
            style={{ backgroundImage: "url('/img/photo-gallery/mk-6.jpg')" }}
          >
            <CardBody background>
              <h6 className={classes.category}>News, Conferences</h6>

              <h3 className={classes.cardTitle}>Tribalism News July 2022</h3>

              <p className={classes.category}>
                The third{" "}
                <a href="https://auckland.measurecamp.org/">
                  Measurecamp Auckland
                </a>
                <br></br>
                event occured on June 18th 2022. Tribalism was there to join in
                the fun at the fisrt Measurecamp in the southern hemisphere
                since October 2019 in Sydney.
                <br />
                <br />
                There was a turnout of roughly 80 attendees, sadly, but
                thankfully as well...
                <br />
                <br />
              </p>
              <h6 className={classes.cardTitle}>Posted: July, 2022</h6>

              <Button
                href="/blog-post/2022/07/tribalism-news-july-2022"
                round
                color="primary"
              >
                <FormatAlignLeft className={classes.icons} /> Read article
              </Button>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={6}>
          <Card
            raised
            background
            style={{
              backgroundImage:
                "url('/img/posts/2022-04-22-website-traffic-prediction/MultipleModels.png')",
            }}
          >
            <CardBody background>
              <h6 className={classes.category}>Data, Tech</h6>

              <h3 className={classes.cardTitle}>
                How to predict website traffic in 4 steps
              </h3>

              <p className={classes.category}>
                Making website traffic prediction models suitable for small
                websites.
                <br></br>
                We made website traffic prediction models in Python and placed
                output to Data Studio for live monitoring.
                <br></br>
                <br></br>
                <br />
                <br />
              </p>
              <h6 className={classes.cardTitle}>Posted: April, 2022</h6>

              <Button
                href="/blog-post/2022/04/website-traffic-prediction"
                round
                color="primary"
              >
                <FormatAlignLeft className={classes.icons} /> Read article
              </Button>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={6}>
          <Card
            raised
            background
            style={{
              backgroundImage: "url('/img/posts/2022-03-17-ga4-opinion/8.jpg')",
            }}
          >
            <CardBody background>
              <h6 className={classes.category}>Analytics, Other</h6>

              <h3 className={classes.cardTitle}>
                GA4 - UA Deprecation Date - Our Opinion
              </h3>

              <p className={classes.category}>
                GA4 is better than Universal analytics...{" "}
                <strong>
                  <i>at measuring website/app performance</i>
                </strong>
                . The event based model is seriously cool and having 50 data
                slots per event (instead of the current 3) is awesome! The new
                tools like explorer are really neat.
                <br />
                <br />
              </p>
              <h6 className={classes.cardTitle}>Posted: Mar, 2022</h6>

              <Button
                href="/blog-post/2022/03/ga4-opinion"
                round
                color="primary"
              >
                <FormatAlignLeft className={classes.icons} /> Read article
              </Button>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={6}>
          <Card
            raised
            background
            style={{
              backgroundImage:
                "url('/img/posts/2022-02-21-bring-website-back-from-the-dead/34.webp')",
            }}
          >
            <CardBody background>
              <h6 className={classes.category}>Tech, Other</h6>

              <h3 className={classes.cardTitle}>
                Bringing a website back from the dead!
              </h3>

              <p className={classes.category}>
                Back in 2012/13/14 I got into building my own websites and the
                most consequential one was scottsunderland.net. Now this was
                just a small website - it only consisted of 6 blog posts, an
                about me page and a contact me page. But its framework of
                wordpress/cornerstone/x-theme would become the basis of the
                first Tribalism website created in October 2016.
                <br />
                <br />
              </p>
              <h6 className={classes.cardTitle}>Posted: Feb, 2022</h6>

              <Button
                href="/blog-post/2022/02/bring-website-back-from-the-dead"
                round
                color="primary"
              >
                <FormatAlignLeft className={classes.icons} /> Read article
              </Button>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={6}>
          <Card
            raised
            background
            style={{
              backgroundImage:
                "url('/img/posts/2022-01-06-URLFragments/url_backg.png')",
            }}
          >
            <CardBody background>
              <h6 className={classes.category}>Data, Tech</h6>

              <h3 className={classes.cardTitle}>
                Track URL Fragments With Google Tag Manager
              </h3>

              <p className={classes.category}>
                When your webpage dynamicaly changes URL as visitor scrolls
                though the page content, you should not use Scroll Depth tracker
                to see Visitor engagement, but instead you can track URL
                fragments. Read this article for more information.
                <br />
                <br />
              </p>
              <h6 className={classes.cardTitle}>Posted: Jan, 2022</h6>

              <Button
                href="/blog-post/2022/01/track-url-fragments-with-google-tag-manager"
                round
                color="primary"
              >
                <FormatAlignLeft className={classes.icons} /> Read article
              </Button>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={6}>
          <Card
            raised
            background
            style={{
              backgroundImage:
                "url('/img/posts/Rz/blog-image-one-small-resize.webp')",
            }}
          >
            <CardBody background>
              <h6 className={classes.category}>Marketing</h6>

              <h3 className={classes.cardTitle}>
                Has Your LinkedIn Campaign Been Rejected? (June 2021)
              </h3>

              <p className={classes.category}>
                Here at Tribalism one of our many talents is campaign management
                and media creation. We have worked with multiple clients from
                different industries, and have worked on many different types of
                campaigns and have ...
                <br />
                <br />
              </p>
              <h6 className={classes.cardTitle}>Posted: Jun, 2021</h6>

              <Button
                round
                href="/blog-post/2021/06/has-your-linkedin-campaign-been-rejected"
                color="primary"
              >
                <FormatAlignLeft className={classes.icons} /> Read article
              </Button>
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={6}>
          <Card
            raised
            background
            style={{
              backgroundImage:
                "url('/img/posts/Rz/skitch-not-working-on-mac-resize.webp')",
            }}
          >
            <CardBody background>
              <h6 className={classes.category}>Tech, Other</h6>

              <h3 className={classes.cardTitle}>
                Skitch Not Working On Your Mac? (May 2021)
              </h3>

              <p className={classes.category}>
                Is skitch not working on your mac? Skitch is one of our
                favourite tools here at Tribalism... except when it crashed on
                every mac update. For the latest Big Sur May 2021 update see how
                to get it working again here...
                <br />
                <br />
              </p>
              <h6 className={classes.cardTitle}>Posted: May, 2021</h6>

              <Button
                round
                href="/blog-post/2021/05/skitch-not-working-on-mac"
                color="primary"
              >
                <FormatAlignLeft className={classes.icons} /> Read article
              </Button>
            </CardBody>
          </Card>
        </GridItem>

        {inView && (
          <GridItem xs={12} sm={6} md={6}>
            <Card
              raised
              background
              style={{
                backgroundImage:
                  "url('/img/posts/Rz/baliphotos20-min-resize.webp')",
              }}
            >
              <CardBody background>
                <h6 className={classes.category}>Data</h6>

                <h3 className={classes.cardTitle}>The Fake Reviews Economy</h3>

                <p className={classes.category}>
                  Fake reviews... we all know they exist. We all know its a
                  problem - but do we really understand its scale? Should we be
                  worried about how much fake reviews are delegitimising the
                  online econmomy? Fake google reviews, fake amazon reviews,
                  fake whatever reviews... are they all as bad as each other???
                  Can fake reviews be spotted???? Read on for our indepth look.
                  <br />
                  <br />
                </p>
                <h6 className={classes.cardTitle}>Posted: Nov, 2020</h6>

                <Button
                  round
                  href="/blog-post/2020/10/the-fake-reviews-economy"
                  color="primary"
                >
                  <FormatAlignLeft className={classes.icons} /> Read article
                </Button>
              </CardBody>
            </Card>
          </GridItem>
        )}

        <GridItem xs={12} sm={6} md={6}>
          <Card
            raised
            background
            style={{
              backgroundImage:
                "url('/img/posts/2020-08-08-IndigenousPeople/international-day-of-the-worlds-indigenous-peoples-header.jpg')",
            }}
          >
            <CardBody background>
              <h6 className={classes.category}>Data</h6>

              <h3 className={classes.cardTitle}>
                International day of the World's Indigenous People, August 9
              </h3>

              <p className={classes.category}>
                August 9th marks the annual International day of the World's
                Indigenous People. In this time of Global pandemic, more than
                ever indigenous peoples of the world need particular
                consideration...
                <br />
                <br />
              </p>
              <h6 className={classes.cardTitle}>Posted: Aug, 2020</h6>

              <Button
                round
                href="/blog-post/2020/08/international-day-of-the-worlds-indigenous-peoples-australia-august-9th-2020"
                color="primary"
              >
                <FormatAlignLeft className={classes.icons} /> Read article
              </Button>
            </CardBody>
          </Card>
        </GridItem>

        {inView && (
          <GridItem xs={12} sm={6} md={6}>
            <Card
              raised
              background
              style={{
                backgroundImage:
                  "url('/img/posts/Rz/COVID-19_Map-resize.webp')",
              }}
            >
              <CardBody background>
                <h6 className={classes.category}>Data</h6>

                <h3 className={classes.cardTitle}>
                  Using search data to identify covid-19 hotspots in Australia
                </h3>

                <p className={classes.category}>
                  The only way to get location data from searchers on google is
                  via paid ads... read on for more 😀
                  <br />
                  <br />
                </p>
                <h6 className={classes.cardTitle}>Posted: Jul, 2020</h6>

                <Button
                  round
                  href="/blog-post/2020/07/covid-search-data"
                  color="primary"
                >
                  <FormatAlignLeft className={classes.icons} /> Read article
                </Button>
              </CardBody>
            </Card>
          </GridItem>
        )}
        {inView && (
          <GridItem xs={12} sm={6} md={6}>
            <Card
              raised
              background
              style={{
                backgroundImage: "url('/img/posts/Rz/errors-resize.webp')",
              }}
            >
              <CardBody background>
                <h6 className={classes.category}>Data</h6>

                <h3 className={classes.cardTitle}>
                  Data Studio Extract: Discrepancies with Google Analytics and
                  other Google tools
                </h3>

                <p className={classes.category}>
                  This tweet ended up in a bit of a firestorm. Scroll through it
                  to see where I and others got involved. On the back of it I
                  decided to really prove the data frustrations I was getting
                  with Data Studio and "Data Extract".
                  <br />
                  <br />
                </p>
                <h6 className={classes.cardTitle}>Posted: Jun, 2020</h6>
                <Button
                  round
                  href="/blog-post/2020/06/data-studio-extract-google-analytics-errors"
                  color="primary"
                >
                  <FormatAlignLeft className={classes.icons} /> Read article
                </Button>
              </CardBody>
            </Card>
          </GridItem>
        )}
        {inView && (
          <GridItem xs={12} sm={6} md={6}>
            <Card
              raised
              background
              style={{
                backgroundImage:
                  "url('/img/posts/Rz/newgooglemaps16-resize.webp')",
              }}
            >
              <CardBody background>
                <h6 className={classes.category}>Data</h6>

                <h3 className={classes.cardTitle}>
                  Guide to google maps in data studio (may 2020)
                </h3>

                <p className={classes.category}>
                  Data Studio, data studio, data studio… such a great tool - but
                  always missing that last little bit. There's been lots of
                  great visualizations made with data studio but when you've
                  wanted to push it...
                  <br />
                  <br />
                </p>
                <h6 className={classes.cardTitle}>Posted: May, 2020</h6>
                <Button
                  round
                  href="/blog-post/2020/05/google-maps-in-data-studio"
                  color="primary"
                >
                  <FormatAlignLeft className={classes.icons} /> Read article
                </Button>
              </CardBody>
            </Card>
          </GridItem>
        )}
        {inView && (
          <GridItem xs={12} sm={6} md={6}>
            <Card
              raised
              background
              style={{
                backgroundImage: "url('/img/posts/Rz/1-resize.webp')",
              }}
            >
              <CardBody background>
                <h6 className={classes.category}>Marketing</h6>

                <h3 className={classes.cardTitle}>
                  Right Time, Right Place Advertising? Is it as good as they
                  say?
                </h3>

                <p className={classes.category}>
                  Amongst clients, friends and colleagues in the digital
                  marketing and analytics industry there seems to be an unending
                  stream of hype surrounding the ability to traget people with
                  “Right time, Right place” (RTRP) advertising...
                  <br />
                  <br />
                </p>
                <h6 className={classes.cardTitle}>Posted: Feb, 2020</h6>
                <Button
                  round
                  href="/blog-post/2020/02/right-time-right-place-advertising"
                  color="primary"
                >
                  <FormatAlignLeft className={classes.icons} /> Read article
                </Button>
              </CardBody>
            </Card>
          </GridItem>
        )}
        
        {inView && (
          <GridItem xs={12} sm={6} md={6}>
            <Card
              raised
              background
              style={{
                backgroundImage: "url('/img/posts/Rz/1-auckland-resize.webp')",
              }}
            >
              <CardBody background>
                <h6 className={classes.category}>Marketing</h6>

                <h3 className={classes.cardTitle}>
                  Auckland Measurecamp 2019 Talk: The Fake Reviews Economy
                </h3>

                <p className={classes.category}>
                  Here is the fake reviews talk Scott gave at Auckland
                  measurecamp...
                  <br />
                  <br />
                </p>
                <h6 className={classes.cardTitle}>Posted: Jun, 2019</h6>
                <Button
                  round
                  href="/blog-post/2019/06/auckland-measurcamp-2019"
                  color="primary"
                >
                  <FormatAlignLeft className={classes.icons} /> Read article
                </Button>
              </CardBody>
            </Card>
          </GridItem>
        )}
        {inView && (
          <GridItem xs={12} sm={6} md={6}>
            <Card
              raised
              background
              style={{
                backgroundImage: "url('/img/posts/Rz/1-naturally-resize.webp')",
              }}
            >
              <CardBody background>
                <h6 className={classes.category}>Marketing</h6>
                <h3 className={classes.cardTitle}>
                  Upcoming SEO Talk at Naturally Good Conference
                </h3>
                <p className={classes.category}>
                  Upcoming SEO Talk at Naturally Good Conference... find our
                  more
                  <br />
                  <br />
                </p>
                <h6 className={classes.cardTitle}>Posted: May, 2019</h6>
                <Button
                  round
                  href="/blog-post/2019/05/seo-talk-naturally-good"
                  color="primary"
                >
                  <FormatAlignLeft className={classes.icons} /> Read article
                </Button>
              </CardBody>
            </Card>
          </GridItem>
        )}
        {inView && (
          <GridItem xs={12} sm={6} md={6}>
            <Card
              raised
              background
              style={{
                backgroundImage: "url('/img/posts/Rz/1-emoji-resize.webp')",
              }}
            >
              <CardBody background>
                <h6 className={classes.category}>Marketing</h6>

                <h3 className={classes.cardTitle}>
                  Emoji / Machine Learning App On GCP - WAW Talk Nov 2018
                </h3>

                <p className={classes.category}>
                  A talk we gave at Web Analytics Wednesday Melbounre on
                  2018-11-21, going over our side project: using machine
                  learning to determine users’ most frequently used emojis and
                  assess their emotions....
                  <br />
                  <br />
                </p>
                <h6 className={classes.cardTitle}>Posted: Nov, 2018</h6>
                <Button
                  round
                  href="/blog-post/2018/11/emoji-machine-learning-app"
                  color="primary"
                >
                  <FormatAlignLeft className={classes.icons} /> Read article
                </Button>
              </CardBody>
            </Card>
          </GridItem>
        )}
        {inView && (
          <GridItem xs={12} sm={6} md={6}>
            <Card
              raised
              background
              style={{
                backgroundImage: "url('/img/posts/Rz/1-ai-resize.webp')",
              }}
            >
              <CardBody background>
                <h6 className={classes.category}>Marketing</h6>

                <h3 className={classes.cardTitle}>
                  Analysts and their AI Friends
                </h3>

                <p className={classes.category}>
                  A talk Scott gave at Mesurecamp Melbourne talking about the
                  future of Analytics and in particular the use of AI...
                  <br />
                  <br />
                </p>
                <h6 className={classes.cardTitle}>Posted: Mar, 2018</h6>
                <Button
                  round
                  href="/blog-post/2018/03/analysts-and-ai"
                  color="primary"
                >
                  <FormatAlignLeft className={classes.icons} /> Read article
                </Button>
              </CardBody>
            </Card>
          </GridItem>
        )}
        {inView && (
          <GridItem xs={12} sm={6} md={6}>
            <Card
              raised
              background
              style={{
                backgroundImage: "url('/img/posts/Rz/1-human-resize.webp')",
              }}
            >
              <CardBody background>
                <h6 className={classes.category}>Marketing</h6>

                <h3 className={classes.cardTitle}>
                  Learning that Humans are Better than Machines – Measurecamp
                  Melbourne 2018 Talk
                </h3>

                <p className={classes.category}>
                  My talk focused on the fallibility of machines and artificial
                  intelligence. In my opinion, everyone is in a rush to develop
                  an “intelligent model” to solve their ...
                  <br />
                  <br />
                </p>
                <h6 className={classes.cardTitle}>Posted: Feb, 2018</h6>
                <Button
                  round
                  href="/blog-post/2018/02/humans-are-better-than-machines"
                  color="primary"
                >
                  <FormatAlignLeft className={classes.icons} /> Read article
                </Button>
              </CardBody>
            </Card>
          </GridItem>
        )}

        {inView && (
          <GridItem xs={12} sm={6} md={6}>
            <Card
              raised
              background
              style={{
                backgroundImage: "url('/img/posts/Rz/1-gaiq-resize.webp')",
              }}
            >
              <CardBody background>
                <h6 className={classes.category}>Marketing</h6>

                <h3 className={classes.cardTitle}>
                  Doing the gaiq exam live (in less than 30mins) at mMasurecamp
                  Sydney 2017
                </h3>

                <p className={classes.category}>
                  Jack and Scott doing the GAIQ live in under 30mins at Sydney
                  Measurecamp...
                  <br />
                  <br />
                </p>
                <h6 className={classes.cardTitle}>Posted: Feb, 2018</h6>
                <Button
                  round
                  href="/blog-post/2018/02/gaiq-exam-in-30mins"
                  color="primary"
                >
                  <FormatAlignLeft className={classes.icons} /> Read article
                </Button>
              </CardBody>
            </Card>
          </GridItem>
        )}

        {inView && (
          <GridItem xs={12} sm={6} md={6}>
            <Card
              raised
              background
              style={{
                backgroundImage: "url('/img/posts/Rz/1-data-eng-resize.webp')",
              }}
            >
              <CardBody background>
                <h6 className={classes.category}>Marketing</h6>

                <h3 className={classes.cardTitle}>
                  Review: I completed Data Engineering on Google Cloud Platform
                  Specialization (Coursera)
                </h3>

                <p className={classes.category}>
                  A full, in depth review of the course :Data Engineering on
                  Google Cloud Platform Specialization (Coursera)
                  <br />
                  <br />
                </p>
                <h6 className={classes.cardTitle}>Posted: Nov, 2017</h6>
                <Button
                  round
                  href="/blog-post/2017/11/data-engineering-on-gcp-specialization-coursera-review"
                  color="primary"
                >
                  <FormatAlignLeft className={classes.icons} /> Read article
                </Button>
              </CardBody>
            </Card>
          </GridItem>
        )}

        {inView && (
          <GridItem xs={12} sm={6} md={6}>
            <Card
              raised
              background
              style={{
                backgroundImage:
                  "url('/img/posts/Rz/1-measure-sydney-resize.webp')",
              }}
            >
              <CardBody background>
                <h6 className={classes.category}>Marketing</h6>

                <h3 className={classes.cardTitle}>
                  Measurecamp Sydney 2017 - Review
                </h3>

                <p className={classes.category}>
                  An in depth review of the 2017 Sydney measurecamp
                  <br />
                  <br />
                </p>
                <h6 className={classes.cardTitle}>Posted: Nov, 2017</h6>
                <Button
                  round
                  href="/blog-post/2017/11/measurecamp-sydney-2017-review"
                  color="primary"
                >
                  <FormatAlignLeft className={classes.icons} /> Read article
                </Button>
              </CardBody>
            </Card>
          </GridItem>
        )}

        {inView && (
          <GridItem xs={12} sm={6} md={6}>
            <Card
              raised
              background
              style={{
                backgroundImage: "url('/img/posts/Rz/1-digital-resize.webp')",
              }}
            >
              <CardBody background>
                <h6 className={classes.category}>Marketing</h6>

                <h3 className={classes.cardTitle}>
                  Measurecamp 2016 - Attribution And Military Tactics In Digital
                  Marketing
                </h3>

                <p className={classes.category}>
                  Scotts talk comparing digital marketing and military tactics -
                  espeically in relation to Attribution...
                  <br />
                  <br />
                </p>
                <h6 className={classes.cardTitle}>Posted: Oct, 2016</h6>
                <Button
                  round
                  href="/blog-post/2016/10/attribution-and-military-tactics-in-digital-marketing"
                  color="primary"
                >
                  <FormatAlignLeft className={classes.icons} /> Read article
                </Button>
              </CardBody>
            </Card>
          </GridItem>
        )}
      </GridContainer>
    </div>
  );
}
